import { createGroupStructureUp } from "./createGroupStructureSubida";

export const parseCargaData = (rawData) => {
  const parsedData = {
    ...rawData,
    ExcelCarga: JSON.parse(rawData.ExcelCarga),
    Settings: JSON.parse(rawData.Settings),
  };

  const groupedData = parsedData.ExcelCarga.data.reduce((acc, pasajero) => {
    const group = pasajero.Grupo;
    if (!acc[group]) acc[group] = [];
    acc[group].push(pasajero);
    return acc;
  }, {});

  const groups = Object.keys(groupedData).map((group) => {
    const groupData = groupedData[group];
    return createGroupStructureUp(groupData, parsedData.Settings);
  });

  return { groups };
};
